module.exports = __webpack_public_path__ + "static/media/home.90f361c7.svg";